// YYYYMMDD hhmmss
export function getFullTime(date){
    return `${date.getFullYear()}/${date.getMonth()+1}/${date.getDate()} ${date.getHours() > 9 ? date.getHours() : "0"+date.getHours()}:${date.getMinutes() > 9 ? date.getMinutes() : "0"+date.getMinutes()}:${date.getSeconds() > 9 ? date.getSeconds() : "0"+date.getSeconds()}`
}
export function timeFormatStandardToString(timeString){
    return `${timeString.slice(0,4)}-${timeString.slice(5,7)}-${timeString.slice(8,10)}T${timeString.slice(11,19)}`
}